import React, { useEffect, useRef, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
import "pdfjs-dist/build/pdf.worker.mjs";
import 'pdfjs-dist/web/pdf_viewer.css';
import { ZoomMode, cursorImage } from '../../helpers/zoomHelpers';

export const PdfViewer = ({ selectedFile, page, setPages }: {
    selectedFile: string,
    page: number,
    setPages: (count: number | null) => void
}) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const [scale, setScale] = useState(1);
    const [zoomMode, setZoomMode] = useState(ZoomMode.IN);

    const handleZoom = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        switch (zoomMode) {
            case ZoomMode.DISABLE:
                break;
            case ZoomMode.IN:
                applyZoom(scale + 1, event);
                setZoomMode(ZoomMode.OUT);
                break;
            case ZoomMode.OUT:
                if (scale > 1) {
                    applyZoom(scale - 1, event);
                    setZoomMode(ZoomMode.IN);
                }
                break;
        }
    };

    const applyZoom = (newScale: number, event: React.MouseEvent) => {
        setScale(newScale)
    }

    useEffect(() => {
        // Store operation
        let renderTask: any = null;

        const loadPdf = async () => {
            try {
                pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

                const loadingTask = pdfjsLib.getDocument(selectedFile);
                const pdfDocument = await loadingTask.promise;

                const pdfPage = await pdfDocument.getPage(page);
                const pages = pdfDocument.numPages
                setPages(pages);

                let rotation = pdfPage.rotate;
                const viewport = pdfPage.getViewport({ scale: scale, rotation: rotation });

                if (viewport.rotation !== rotation) {
                    rotation = viewport.rotation;
                }

                if (canvasRef.current) {
                    const canvas = canvasRef.current;
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;

                    const ctx = canvas.getContext('2d');
                    if (ctx) {
                        if (renderTask) {
                            // Cancel prev operation
                            renderTask.cancel();
                        }

                        renderTask = pdfPage.render({
                            canvasContext: ctx,
                            viewport,
                        });

                        await renderTask.promise;

                        canvasRef.current!.scrollIntoView({
                            behavior: 'auto',
                            block: 'center',
                            inline: 'center'
                        });
                    }

                    if (scale === 1) {
                        // Фиксит иногда не правильный поворот документа при загрузке в первый раз
                        setTimeout(() => setScale(1.01), 10);
                    }
                }
            } catch (error) {
                console.error('Error loading PDF:', error);
            }
        };

        loadPdf();
    }, [selectedFile, scale, page]);

    return (
        <div
            className={zoomMode === ZoomMode.OUT ? "" : "w-full h-full flex flex-col items-center justify-center relative"}
            onClick={handleZoom}
            style={{
                cursor: cursorImage(zoomMode)
            }}>
            <canvas ref={canvasRef}></canvas>
        </div>
    )
}
